import React from 'react';
import { NavLink } from 'react-router-dom';

const logoIcon = require('./../../images/logo-icon.png');
const bsCladsLogo = require('./../../images/bs-clads-logo.png');

class Navigation extends React.Component {

    handleNavClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.props.closeNav) {
            this.props.closeNav();
        }
    };

    render() {
        const { isScrolled } = this.props;

        const defaultTextColor = isScrolled ? '#111111' : '#ffffff';
        const pathname = typeof window !== 'undefined' ? window.location.pathname : '';

        const isHomeActive = pathname === '/';
        const isAboutActive = pathname === '/about-us';
        const isProductsActive = pathname === '/products' || pathname.startsWith('/product');
        const isProjectsActive = pathname === '/projects' || pathname.startsWith('/project');
        const isContactActive = pathname === '/contact-us';

        return (
            <>
                {/* MOBILE DRAWER HEADER BAR WITH LOGO & X CLOSE BUTTON */}
                <div className="mobile-drawer-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', paddingBottom: '12px', marginBottom: '8px', borderBottom: '1px solid rgba(255, 255, 255, 0.1)', flexShrink: 0 }}>
                    <NavLink to="/" onClick={this.handleNavClick} style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
                        <img src={logoIcon} alt="BS Icon" style={{ height: '34px', width: 'auto', objectFit: 'contain', margin: 0, padding: 0, display: 'block' }} />
                        <img src={bsCladsLogo} alt="bs clads" style={{ height: '34px', width: 'auto', objectFit: 'contain', margin: 0, padding: 0, display: 'block' }} />
                    </NavLink>

                    <button
                        type="button"
                        className="mobile-drawer-close"
                        onClick={this.props.closeNav || this.props.toggleNav}
                        aria-label="Close Menu"
                        title="Close Menu"
                        style={{ background: 'none', border: 'none', color: '#ffffff', fontSize: '22px', cursor: 'pointer', padding: '4px', lineHeight: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    >
                        <i className="fa fa-times" />
                    </button>
                </div>

                <ul className="nav navbar-nav align-items-center" style={{ flexShrink: 0 }}>
                    <li><NavLink to="/" end onClick={this.handleNavClick} className={({ isActive }) => (isActive || isHomeActive ? 'active' : '')} style={({ isActive }) => ({ color: (isActive || isHomeActive) ? '#f03a02' : defaultTextColor, textDecoration: 'none', fontWeight: (isActive || isHomeActive) ? '800' : '700' })}>Home</NavLink></li>
                    <li><NavLink to="/about-us" onClick={this.handleNavClick} className={({ isActive }) => (isActive || isAboutActive ? 'active' : '')} style={({ isActive }) => ({ color: (isActive || isAboutActive) ? '#f03a02' : defaultTextColor, textDecoration: 'none', fontWeight: (isActive || isAboutActive) ? '800' : '700' })}>About Us</NavLink></li>
                    <li><NavLink to="/products" onClick={this.handleNavClick} className={({ isActive }) => (isActive || isProductsActive ? 'active' : '')} style={({ isActive }) => ({ color: (isActive || isProductsActive) ? '#f03a02' : defaultTextColor, textDecoration: 'none', fontWeight: (isActive || isProductsActive) ? '800' : '700' })}>Products</NavLink></li>
                    <li><NavLink to="/projects" onClick={this.handleNavClick} className={({ isActive }) => (isActive || isProjectsActive ? 'active' : '')} style={({ isActive }) => ({ color: (isActive || isProjectsActive) ? '#f03a02' : defaultTextColor, textDecoration: 'none', fontWeight: (isActive || isProjectsActive) ? '800' : '700' })}>Projects</NavLink></li>
                    <li><NavLink to="/contact-us" onClick={this.handleNavClick} className={({ isActive }) => (isActive || isContactActive ? 'active' : '')} style={({ isActive }) => ({ color: (isActive || isContactActive) ? '#f03a02' : defaultTextColor, textDecoration: 'none', fontWeight: (isActive || isContactActive) ? '800' : '700' })}>Contact Us</NavLink></li>
                    
                    {/* OWNER CONTACT TEXT (DESKTOP ONLY - HIDDEN ON MOBILE DRAWER) */}
                    <li className="header-contact-text-item desktop-only-contact" style={{ marginLeft: '25px', display: 'flex', alignItems: 'center' }}>
                        <a
                            href="tel:+918144370659"
                            style={{
                                display: 'block',
                                textAlign: 'right',
                                textDecoration: 'none',
                                lineHeight: '1.25',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <div style={{
                                display: 'block',
                                fontSize: '14.5px',
                                fontWeight: '700',
                                color: isScrolled ? '#111111' : '#ffffff',
                                textTransform: 'lowercase',
                                letterSpacing: '0.5px'
                            }}>
                                raj vikram das
                            </div>
                            <div style={{
                                display: 'block',
                                fontSize: '14.5px',
                                fontWeight: '800',
                                color: '#f03a02',
                                letterSpacing: '0.5px',
                                marginTop: '2px'
                            }}>
                                +91 81443 70659
                            </div>
                        </a>
                    </li>
                </ul>

                {/* MOBILE DRAWER FOOTER (Visible on mobile screen <= 991px) */}
                <div className="mobile-drawer-footer" style={{ marginTop: 'auto', paddingTop: '16px', borderTop: '1px solid rgba(255, 255, 255, 0.1)', width: '100%', textAlign: 'left', flexShrink: 0 }}>
                    <div className="mobile-contact-info" style={{ display: 'flex', flexDirection: 'column', gap: '6px', textAlign: 'left', alignItems: 'flex-start', margin: 0, padding: 0 }}>
                        {/* Line 1: Name */}
                        <span className="mobile-footer-name" style={{ fontWeight: '800', color: '#ffffff', fontSize: '14px', letterSpacing: '0.5px', display: 'block', margin: 0, padding: 0 }}>
                            raj vikram das
                        </span>
                        
                        {/* Line 2: Phone (Orange Color #f03a02) */}
                        <a href="tel:+918144370659" className="mobile-footer-phone" style={{ color: '#f03a02', fontWeight: '800', fontSize: '14.5px', textDecoration: 'none', display: 'block', margin: 0, padding: 0 }}>
                            +91 81443 70659
                        </a>

                        {/* Line 3: Email */}
                        <a href="mailto:rajvikramdas@bsclads.com" className="mobile-footer-email" style={{ color: '#cccccc', fontSize: '13px', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', margin: 0, padding: 0 }}>
                            <i className="fa fa-envelope" style={{ color: '#f03a02', fontSize: '13px' }} />
                            <span>rajvikramdas@bsclads.com</span>
                        </a>
                    </div>

                    {/* <div className="mobile-social-icons" style={{ marginTop: '16px', display: 'flex', gap: '14px', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <a href="https://twitter.com" target="_blank" rel="noreferrer" title="Twitter" aria-label="Twitter" style={{ width: '34px', height: '34px', borderRadius: '50%', backgroundColor: 'rgba(255, 255, 255, 0.15)', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', textDecoration: 'none' }}>
                            <i className="fa fa-twitter" />
                        </a>
                        <a href="https://www.instagram.com" target="_blank" rel="noreferrer" title="Instagram" aria-label="Instagram" style={{ width: '34px', height: '34px', borderRadius: '50%', backgroundColor: 'rgba(255, 255, 255, 0.15)', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', textDecoration: 'none' }}>
                            <i className="fa fa-instagram" />
                        </a>
                        <a href="https://www.facebook.com" target="_blank" rel="noreferrer" title="Facebook" aria-label="Facebook" style={{ width: '34px', height: '34px', borderRadius: '50%', backgroundColor: 'rgba(255, 255, 255, 0.15)', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', textDecoration: 'none' }}>
                            <i className="fa fa-facebook" />
                        </a>
                        <a href="https://wa.me/918144370659" target="_blank" rel="noreferrer" title="WhatsApp" aria-label="WhatsApp" style={{ width: '34px', height: '34px', borderRadius: '50%', backgroundColor: 'rgba(255, 255, 255, 0.15)', color: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '15px', textDecoration: 'none' }}>
                            <i className="fa fa-whatsapp" />
                        </a>
                    </div> */}
                </div>
            </>
        );
    }
}

export default Navigation;